/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {Route} from "react-router-dom";

const CommonRoute = ({
  component: Component,
  layout: Layout,
  ...rest
}: {
  component: any;
  layout: any;
  exact?: boolean;
  path: string;
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default CommonRoute;
